module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Communication/Adress-book2-f777f5d93aa26dab2c028c791954ece5.svg";